import AccordianStyles from "./Accordian.module.scss";
import DownArrow from "../../assets/images/downArrowIcon.svg";
import SidebarDownArrow from "../../assets/sidebar/sidebarDropdownArrow.svg";
import visibilityIconActive from "../../assets/images/visibility.svg";
import visibilityIconInActive from "../../assets/images/visibility_off.svg";
import { useState } from "react";
import React from "react";
const SuggestionsAccordian = ({
  children,
  title,
  theme,
  className,
  defaultOpen=false,
}: {
  children?: any;
  title: any;
  theme: "comments" | "default" | "sidebar";
  className?: any;
  defaultOpen: boolean;
}) => {
  const [showContent, setShowContent] = useState(defaultOpen);

  const toggleContent = () => {
    setShowContent(!showContent);
  };

  const handleShowContent = (val: boolean) => {
    setShowContent(val);
  };

  return (
    <div
      className={`${AccordianStyles.accWrapper} ${AccordianStyles[theme]} ${className}`}
    >
      <div onClick={toggleContent} className={AccordianStyles.title}>
        <div className={AccordianStyles.suggestions}>
          {theme !== "sidebar" && (
            <img
              src={showContent ? visibilityIconActive : visibilityIconInActive}
              className={`${AccordianStyles.arrowImg}`}
              alt=""
            />
          )}
          <span>{title}</span>
        </div>
        <img
          src={theme === "sidebar" ? SidebarDownArrow : DownArrow}
          className={`${AccordianStyles.arrowImg} ${
            showContent ? AccordianStyles.active : ""
          }`}
          alt=""
        />
      </div>

      {children && (
        <div className={`${AccordianStyles.content} ${theme !== "sidebar" && !showContent && AccordianStyles.contentInActive}`}>
          <div
            className={`${AccordianStyles.child} ${
              showContent && AccordianStyles.active
            }`}
          >
            {React.Children.map(children, (child) => {
              return React.cloneElement(child, { handleShowContent });
            })}
          </div>
          {theme !== "sidebar" && showContent && 
            (<div className={AccordianStyles.showLess} onClick={toggleContent}>
              <span>Show less</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SuggestionsAccordian;
